import React from 'react';

// material-ui
import { Box, IconButton, Stack, Tooltip, Typography, Zoom } from '@mui/material';
import useFileUpload from 'hooks/useFileHandler';
import DownloadIcon from '@mui/icons-material/Download';
import LynIcon from 'components/@extended/LynIcon';

const AttachmentFileDownload = ({ attachment }) => {
	const file = JSON.parse(attachment);
	const { downloadFileHandler } = useFileUpload();
	// console.log("file", file);
	const onDownload = (file) => {
		// const api = "/download-chat-file-id";
		const api = '/download-file-by-file-id';
		const payload = {
			fileId: file.fileId,
		};
		downloadFileHandler(payload, file.fileName, api);
	};

	return (
		<Box
			sx={{
				width: '300px',
				maxWidth: '300px',
				display: 'flex',
				overflow: 'hidden',
				bgcolor: '#ffffff',
				borderRadius: '5px',
				p: '5px',
				ml: '-7px',
				mr: '-7px',
				mt: '-5px',
			}}
		>
			<Stack
				direction="row"
				justifyContent="space-between"
				alignItems="center"
				sx={{ p: 1, border: '1px solid #e6ebf1', borderRadius: '5px', width: '100%' }}
				spacing={0.5}
			>
				<Stack direction="row" alignItems="center" justifyContent="center" spacing={1} sx={{ cursor: 'default', minWidth: 0 }}>
					<LynIcon fileName="attachment" folder="icons" format="svg" sx={{ width: '16px', height: '16px' }} />
					<Tooltip
						slotProps={{
							popper: {
								modifiers: [
									{
										name: 'offset',
										options: {
											offset: [0, -10],
										},
									},
								],
							},
						}}
						title={file.fileName}
						placement="top"
						TransitionComponent={Zoom}
					>
						{/* This noWrap will now work correctly within the constrained Stack */}
						<Typography variant="body1" noWrap color="initial">
							{file.fileName}
						</Typography>
					</Tooltip>
				</Stack>
				<IconButton aria-label="file download" size="small" onClick={() => onDownload(file)}>
					<DownloadIcon />
				</IconButton>
			</Stack>
		</Box>
	);
};

export default AttachmentFileDownload;
